import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/system";
import theme from "./theme"

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme = {theme}>
    <BrowserRouter>
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          preventDuplicate
        >
          <App />
        </SnackbarProvider>
     </BrowserRouter>
     </ThemeProvider>
  </React.StrictMode>,
   document.getElementById("root")
);
